import tippy, { Content, type Instance, type Props } from "tippy.js";
import { canv } from "@/canv/global";

export type CommentsPopoverMode = "preview" | "window";

export class CommentsPopovers {
    initCommentsPopover = (mode: CommentsPopoverMode, UID: string, props: Partial<Props>) => {
        this[mode].instance = tippy(document.body, {
            ...props,
            arrow: false,
            allowHTML: true,
            delay: 0,
            trigger: "manual",
            placement: "right-start",
            theme: "comment",
            interactive: true,
            hideOnClick: false,
            zIndex: mode === "window" ? 2 : 1,
            offset: [-23, 25],
        });

        this[mode].UID = UID;
    };

    hideCommentsPopovers(mode?: CommentsPopoverMode) {
        if (!mode) {
            this.hideCommentsPopovers("preview");
            this.hideCommentsPopovers("window");
            return;
        }

        if (mode === "window") {
            canv.appInterface.inputFocused = 0;
        }

        this[mode].UID = "";
        this[mode].instance?.hide();
    }

    setPopoverProps(mode: CommentsPopoverMode, UID: string, props: Partial<Props>) {
        if (!this[mode].instance) return;

        this[mode].instance.setProps(props);
        this[mode].UID = UID;
    }

    preview: { UID: string; instance: Instance | null } = { UID: "", instance: null };
    window: { UID: string; instance: Instance | null } = { UID: "", instance: null };
}
